import React from 'react';

export const CouponInfo = () => {
    return null;
};
